<template>
  <section v-on:click="sectionClicked">
    <Header ref="header" :class="{scrolled: scrolled}"/>
    <div class="loadingFull" v-if="loading"></div>
    <div class="notFoundCnt" v-else-if="!detail">>
      <div class="notFound">
        <img src="../assets/not-found.png">
        <h4>404</h4>
        <h2>Halaman tidak ditemukan</h2>
        <p>We can't find the page you looking for</p>
        <button v-on:click="this.$router.push('/')"
          class="btn secondary">Back To Home</button>
      </div>
    </div>
    <div class="contentWrapper" v-else>
      <div class="aboutContent">
        <div class="cnt">
          <div class="posts main">
            <div class="post">
              <div class="avatar hasPict" v-if="detail.user">{{detail.user.name.substr(0, 1)}}</div>
              <div class="postContent">
                <div class="postTop">
                  <h4 v-if="detail.user">{{detail.user.name}}</h4>
                  <span class="ts">{{detail.timestamp * 1000
                    | moment('DD MMMM YYYY HH:mm')}}</span>
                </div>
                <div class="postUserContent">
                  {{detail.content}}
                </div>
                <div class="replyPost" v-on:click="replyPost(detail)">
                  <div class="icon chatbubbleEllipsesOutline"></div>
                  Tulis Balasan
                </div>
                <span class="totalReply" v-if="detail.disscusionCount > 0"><b>
                  {{detail.disscusionCount}} </b> balasan</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mainDivider"></div>
      <div class="aboutContent">
        <div class="cnt">
          <div class="posts loading" v-if="loadingReplies"></div>
          <div class="posts" v-else-if="replies.length > 0">
            <div class="post" v-for="(item, i) in replies" :key="`dsc${i}`">
              <div class="avatar hasPict" v-if="item.user">{{item.user.name.substr(0, 1)}}</div>
              <div class="postContent">
                <div class="postTop">
                  <h4 v-if="item.user">{{item.user.name}}</h4>
                  <span class="ts">{{item.timestamp * 1000 | moment('from')}}</span>
                </div>
                <div class="postUserContent">
                  {{item.content}}
                </div>
                <div class="replyPost" v-on:click="replyPost(item)">
                  <div class="icon chatbubbleEllipsesOutline"></div>
                  Tulis Balasan
                </div>
                <div class="discussions" v-if="item.replies && item.replies.length > 0">
                  <div class="discussionCnt" v-if="item.repliesOpen">
                    <div class="discussionItem" v-for="(r, ri) in item.replies" :key="`ri${ri}`">
                      <div class="avatar hasPict">{{r.user.name.substr(0, 1)}}</div>
                      <h4>{{r.user.name}}<span class="ts">
                        {{r.timestamp * 1000 | moment('from')}}</span></h4>
                      <p>{{r.content}}</p>
                    </div>
                  </div>
                  <div class="joinDiscusion" v-on:click="item.repliesOpen = false"
                    v-if="item.repliesOpen">
                    <div class="icon arrowUpOutline"></div>
                    <span>Sembunyikan</span>
                  </div>
                  <div class="joinDiscusion" v-else v-on:click="item.repliesOpen = true">
                    <div class="icon arrowDownOutline"></div>
                    <span>Lihat <b> {{item.replies.length}} </b> balasan</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="endArticle"></div>
    </div>
    <NewPost ref="newPost"/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import NewPost from '@/components/NewPost.vue';

export default {
  name: 'home',
  components: { Header, NewPost },
  data() {
    return {
      loading: true,
      scrolled: false,
      detail: null,
      shareUri: '',
      loadingReplies: true,
      replies: [],
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
    },
    joinGroup() {},
    leaveGroup() {},
    getReplies() {
      const { groupId } = this.$route.params;
      const { postId } = this.$route.params;
      this.$http.get(this.$config.uri(`group/${groupId}/discussion/${postId}/replies`)).then((r) => {
        this.loadingReplies = false;
        this.replies = r.data.status === 200 ? r.data.data : [];
      });
    },
    getDiscussions() {
      this.$http.get(this.$config.uri(`group/${this.detail.id}/discussions`)).then((r) => {
        this.discussions = r.data.status === 200 ? r.data.data : [];
        this.loadingPost = false;
      });
    },
    replyPost(item) {
      this.$refs.newPost.open({
        groupId: this.detail.groupId,
        replyTo: item,
      }, (b, post) => {
        if (!b) return;
        if (item.id === this.detail.id) {
          this.replies.unshift(post);
        } else {
          if (!item.replies) item.replies = []; // eslint-disable-line
          item.replies.unshift(post); // eslint-disable-line
          item.repliesOpen += 1; // eslint-disable-line
        }
      });
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    const { groupId } = this.$route.params;
    const { postId } = this.$route.params;
    this.shareUri = `${this.$config.appUri}group/${groupId}/discussion/${postId}`;
    this.$http.get(this.$config.uri(`group/${groupId}/discussion/${postId}`)).then((r) => {
      this.loading = false;
      this.detail = (r.data.status === 200) ? r.data.data : null;
      this.getReplies();
    });
  },
};
</script>

<style scoped lang="scss">
.articleShare{
  h4{
    margin: 0 0 4px;
    font-size: 12px;
    text-transform: uppercase;
    color: #767676;
    @media (max-width: 680px) {
      display: none;
    }
  }
  .shareCnt{
    display: flex;
    margin-left: -6px;
  }
  a{
    display: block;
    margin-right: 10px;
    .fa{
      width: 40px;
      height: 40px;
      display: block;
      border-radius: 50%;
      margin: 0 auto;
      margin-top: 4px;
      background-size: 26px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .5;
      &:hover{
        background-color: #fff;
        opacity: 1;
      }
    }
    .fa.fa-facebook{
      background-image: url(../assets/share-facebook.png);
    }
    .fa.fa-twitter{
      background-image: url(../assets/share-twitter.png);
    }
    .fa.fa-whatsapp{
      background-image: url(../assets/share-whatsapp.png);
    }
    .fa.fa-telegram{
      background-image: url(../assets/share-telegram.png);
    }
    .fa.fa-email{
      background-image: url(../assets/share-email.png);
    }
  }
  @media (max-width: 1060px) {
    position: fixed;
    display: flex;
    left: 0; right: 0;
    top: auto !important; bottom: 0;
    background-color: #fff;
    transform: none;
    border-radius: 0;
    padding: 10px 20px;
    z-index: 991;
    border-top: #eee 1px solid;
    margin: 0;
    align-items: center;
    &.hidden{
      position: static;
    }
    h4{
      text-align: left;
      margin: 0;
      margin-right: 20px;
      font-size: 17px;
      text-transform: none;
    }
    .shareCnt{
      display: flex;
      a{
        margin: 0;
        margin-right: 10px;
        padding: 0;
        .fa{
          margin: 0;
        }
      }
    }
  }
  @media (max-width: 680px) {
    padding-left: 10px;
  }
}
.mainDivider{
  border-top: #eee 1px solid;
}
.replyPost{
  background-color: #f5f5f5;
  border-radius: 50px;
  padding: 10px 16px;
  margin-top: 10px;
  color: #444;
  cursor: pointer;
  transition: all .3s ease;
  &:hover{
    // box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
    background-color: #e5e5e5;
  }
  .icon{
    float: left;
    margin: -2px 8px -10px 0;
    width: 23px; height: 23px;
    background-image: url(../assets/chatbubble-ellipses-outline.svg);
    background-size: 23px auto;
    background-position: center;
    background-repeat: no-repeat;
  }
}
.contentWrapper{
  min-height: 60vh;
}
.aboutContent{
  max-width: 960px;
  margin: 0 auto;
  .posts{
    padding: 10px 0 40px;
    max-width: 740px;
    margin: 0 auto;
    &.loading{
      height: 400px;
      background-image: url(../assets/loading.svg);
      background-position: center;
      background-repeat: no-repeat;
      background-size: 46px auto;
    }
    &.noPost{
      font-style: italic;
      color: #767676;
      padding: 12px 0;
    }
    .post{
      // border-bottom: #eee 1px solid;
      display: flex;
      padding: 12px 0 14px;
      margin-bottom: 12px;
      .avatar{
        width: 52px; height: 52px;
        background-color: #eee;
        border-radius: 50%;
        margin-right: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
        &.hasPict{
          background-color: #fee66e;
          color: #000;
          font-weight: 800;
          font-size: 22px;
        }
      }
      .postContent{
        width: calc(100% - 68px);
        .postTop{
          display: flex;
          h4{
            margin: 0 0 2px;
            font-size: 16px;
            font-weight: 600;
            margin-right: auto;
          }
          .ts{
            opacity: .65;
            font-size: 15px;
          }
        }
        .totalReply{
          color: #767676;
          margin-top: 10px;
          display: block;
        }
      }
      .discussions{
        margin-top: 10px;
        .discussionItem{
          position: relative;
          padding-left: 42px;
          margin-bottom: 10px;
          .avatar{
            width: 30px; height: 30px;
            position: absolute;
            left: 0; top: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            &.hasPict{
              background-color: #fee66e;
              color: #000;
              font-weight: 800;
              font-size: 14px;
            }
          }
          h4{
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            .ts{
              float: right;
              color: #767676;
              font-weight: 500;
              font-size: 13px;
            }
          }
          p{
            margin: 0;
            font-size: 15px;
          }
        }
        .joinDiscusion{
          padding: 4px 10px 5px;
          border: #02b5ff 1px solid;
          border-radius: 50px;
          display: inline-block;
          font-size: 15px;
          color: #02b5ff;
          cursor: pointer;
          &:hover{
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
          }
          .icon{
            margin: 1px 6px -3px 0;
            width: 18px; height: 18px;
            float: left;
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
            &.arrowUpOutline{
              background-image: url(../assets/arrow-up-outline-blue.svg);
            }
            &.arrowDownOutline{
              background-image: url(../assets/arrow-down-outline-blue.svg);
            }
          }
        }
      }
    }
    &.main{
      min-height: 0;
      margin-top: 96px;
      padding: 20px 0 0;
      @media (max-width: 760px) {
        margin-top: 86px;
        padding: 0;
      }
      .post{
        margin-bottom: 0;
        display: block;
        position: relative;
        .avatar{
          position: absolute;
          left: 0; top: 6px;
        }
        .postTop{
          display: block;
          padding-left: 64px;
          padding-bottom: 20px;
          h4{
            font-size: 17px;
            margin: 0;
          }
          .ts{
            float: none;
            font-size: 14px;
            color: #555;
            opacity: 1;
            margin: 0;
          }
        }
        .postContent{
          width: auto;
        }
        .postUserContent{
          font-size: 22px;
        }
      }
    }
  }
}
</style>
